import {
	type BookingSaveInput,
	useResourceBookingSaveMutation,
} from '@/generated/graphql';
import { useHelpStationStore } from '@/features/HelpStation';
import { useMessage } from '@/features/Message';
import { useTranslation } from '@/composables';
import { type GraphQLFormattedError } from 'graphql';
import type { ApolloError } from '@apollo/client/core';

export const useResourcePlanningUtils = () => {
	const {
		mutate,
		loading: isLoadingSaveBooking,
		onError: onSaveBookingError,
	} = useResourceBookingSaveMutation({});
	const helpStationStore = useHelpStationStore();
	const { addErrorMessage } = useMessage();
	const { t } = useTranslation();

	const handleError = (errors: readonly GraphQLFormattedError[]) => {
		if (!errors.some(({ extensions }) => extensions?.translation)) {
			addErrorMessage({
				message: t('general_save_failed'),
			});
		}
	};

	const handleErrorResponse = ({ graphQLErrors }: ApolloError) => {
		handleError(graphQLErrors);
	};

	const saveBookingMutation = async (
		input: BookingSaveInput
	): ReturnType<typeof mutate> => {
		const response = await mutate({ input });

		helpStationStore.hasUserReviewedBooking = true;

		const errors = response?.errors;
		if (errors) {
			handleError(errors);
		}

		return response;
	};

	onSaveBookingError(({ graphQLErrors }) => handleError(graphQLErrors));

	return {
		saveBookingMutation,
		isLoadingSaveBooking,
		handleError,
		handleErrorResponse,
	};
};
